import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SearchFieldSelect } from "../../../components/textfield";
import "../../../assets/styles/admin/so.scss";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Checkbox,
  Form,
  Popover,
  Typography,
} from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import moment from "moment";
import { numberWithCommas } from "../../../helpers/functions";
import { Content } from "antd/lib/layout/layout";

interface ParamsType {
  id: string;
}

const SO = () => {
  const { id } = useParams<ParamsType>();
  let [form] = Form.useForm();
  const history = useHistory();
  const [customer, setCustomer] = useState<any>([]);
  const [nameTitle, setNameTitle] = useState<any>();
  const { Text, Link } = Typography;

  const [dataSo, setDataSo] = useState<any>([]);

  const CheckboxGroup = Checkbox.Group;
  const dateFormat = "DD-MM-YYYY";

  const columns = [
    {
      title: "",
      dataIndex: "index",
      colSpan: 1,
      render(text: any, record: any, index: number) {
        return index + 1;
      },
    },
    {
      title: "รหัสการขาย/SO",
      dataIndex: "code",
      colSpan: 1,
      width: "40%",
      render: (text: any, data: any, index: number) => {
        return <Popover content={Content(index)}>{text}</Popover>;
      },
    },
    {
      title: "เลขที่ใบยา/Ref.VN",
      dataIndex: "vn",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
    },
    {
      title: "สาขา/Branch",
      dataIndex: "branchname",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render: (text: any, record: any) => {
        return record?.branch?.name;
      },
    },
    {
      title: "วันที่ซื้อ/Purchase Date",
      dataIndex: "formatCreatedAt",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render: (text: any, record: any) => {
        return moment(record?.updatedAt).format("DD-MM-YYYY");
      },
    },
    {
      title: "ราคาขาย/Sale Price",
      dataIndex: "balanceAfterAllDiscount",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render: (text: any) => numberWithCommas(text, 2),
    },
    {
      title: "ชำระแล้ว/Paid",
      dataIndex: "paidCalculate",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render: (text: any) => numberWithCommas(text, 2),
    },
    {
      title: "สถานะการชำระแล้ว/Payment Status",
      dataIndex: "statusPayment", //cashier
      colSpan: 1,
      width: "20%",
      align: "center" as const,

      render: (text: any) => {
        return {
          props: {
            style: {
              background:
                text === "unpaid"
                  ? "#FFCDCD"
                  : text === "paid_full"
                  ? "#C7F0D8"
                  : text === "deposit"
                  ? "#FEEFC7"
                  : "",
              align: "center" as const,
            },
          },
          children: (
            <div
              style={{
                color:
                  text === "unpaid"
                    ? "#E76464"
                    : text === "paid_full"
                    ? "#4D7E7F"
                    : text === "deposit"
                    ? "#F3A086"
                    : "",

                borderColor: "green",
              }}
            >
              {text}
            </div>
          ),
        };
      },
    },
    {
      title: "สถานะคอร์ส/Course Status",
      dataIndex: "status",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render(text: any, record: any) {
        return {
          props: {
            style: {
              background:
                text === "Close Course"
                  ? "#FFCDCD"
                  : text === "pending"
                  ? "#C7F0D8"
                  : text === "waiting_approve"
                  ? "#FEEFC7"
                  : "",
              align: "center" as const,
            },
          },
          children: (
            <div
              style={{
                color:
                  text === "Close Course"
                    ? "#E76464"
                    : text === "pending"
                    ? "#4D7E7F"
                    : text === "waiting_approve"
                    ? "#F3A086"
                    : "",

                borderColor: "green",
              }}
            >
              {text}
            </div>
          ),
        };
      },
      // className: {dataIndex === "Pending" ? "pending-custom" : "close-course"}
    },
    {
      title: "Action",
      colSpan: 1,
      width: "20%",
      align: "center" as const,
      render: (text: any, record: any) => {
        return (
          <div>
            <Icon
              icon="fluent:edit-settings-24-regular"
              color="#5baea9"
              width="24"
              height="24"
              onClick={() => {
                console.log("record", record);
                history.push(`/opd/so-detail/${id}/${record._id}`);
              }}
            />
          </div>
        );
      },
    },
  ];

  const options = [{ value: "Normal" }, { value: "Promotion" }];
  const plainOptions = ["AE", "SU", "WE", "P&P"];

  const getAPIs = async () => {
    getdatahead();
  };

  const getdatahead = async () => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      const headDatas = res?.data;
      console.log(headDatas);

      setNameTitle(
        headDatas?.firstName ? headDatas?.firstName : headDatas?.firstNameEN
      );
      form.setFieldsValue({
        customer:
          (headDatas?.firstName
            ? headDatas?.firstName
            : headDatas?.firstNameEN) +
          " " +
          (headDatas.lastName ? headDatas?.lastName : headDatas?.lastNameEN),
        cn: headDatas?.code,
        mobile: headDatas?.phoneNumbers
          ? headDatas?.phoneNumbers
          : `+${headDatas?.phoneNumbersFirst?.code} ${headDatas?.phoneNumbersFirst?.phone} , +${headDatas?.phoneNumbersSecond?.code} ${headDatas?.phoneNumbersSecond?.phone}`,
        date: moment(headDatas?.birthDate),
      });
      getdatatable();
    });
  };
  const getdatatable = async () => {
    await axios.get(`/so?memberId=${id}`).then((res) => {
      let datas = res?.data?.data;

      console.log("datas", datas);

      setDataSo(datas);
    });
  };

  const onSubmit = (values: any) => {
    console.log("values v1 =>", values);
  };

  // const content = (
  //   <div className="mt-50">
  //     {dataSo.map((data: any) =>
  //       data.items.map((newData: any) => <p>{newData?.itemData?.name}</p>)
  //     )}
  //   </div>
  // );

  function Content(index: number) {
    return (
      <div style={{ width: "200px" }}>
        {dataSo[index].items.map((newData: any) => (
          <Row justify="start">
            <Text style={{ fontSize: "16px" }}>{newData?.itemData?.name}</Text>
          </Row>
        ))}
      </div>
    );
  }
  useEffect(() => {
    console.log("id--", id);
    getAPIs();
  }, []);

  return (
    <div>
      <HeaderBar title="SO" onClick={() => history.goBack()}>
        <MainButton
          title="ซื้อคอร์สเพิ่ม / Purchase More Courses"
          onClick={() => history.push(`/opd/so/buy/${id}`)}
          width="280px"
        />
      </HeaderBar>
      <div style={{ padding: "0px 40px" }}>
        <Form form={form} onFinish={onSubmit}>
          <div style={{ marginTop: "10px" }} className="text-itle">
            <p>ข้อมูลลูกค้า/Customer Information</p>
          </div>
          <div className="card-view-custom" style={{ padding: "20px" }}>
            <Row gutter={[16, 16]} className="custom-card">
              <Col span={6}>
                <p>ชื่อลูกค้า/Customer Name</p>
                <Form.Item name="customer">
                  <Input style={{ padding: "10px !important" }} disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>รหัสลูกค้า/CN</p>
                <Form.Item name="cn">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>เบอร์โทร/Mobile</p>
                <Form.Item name="mobile">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={6}>
                <p>วันเกิด/Birthdate</p>
                <Form.Item name="date">
                  <DatePicker
                    inputReadOnly
                    disabled
                    format={dateFormat}
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "1px solid #d9d9d9",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div style={{ marginTop: "40px" }} className="text-itle">
            <p>รายการสั่งซื้อ/SO List</p>
          </div>

          <div className="input-search" style={{ marginTop: "15px" }}>
            <Select
              bordered={false}
              placeholder="Search By SO"
              suffixIcon={
                <Icon
                  icon="ant-design:caret-down-filled"
                  style={{ color: "#AEAEAE" }}
                />
              }
              onChange={(e) => {
                // setDataSearch({ ...dataSearch, typeSearch: e})
                // setIsDisable({...isDisable, isSearch: true})
              }}
              // options={types}
            />
            <Input.Search
              bordered={false}
              // disabled={ isDisable?.isSearch ? false : true}
              onSearch={(e) => {
                // setDataSearch({ ...dataSearch, search: e})
              }}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <div style={{ marginTop: "20px" }} className="table-data">
              <Table
                columns={columns}
                dataSource={dataSo}
                bordered
                scroll={{ x: 1200 }}
                rowKey="_id"
                // onRow={(record, rowIndex) => {
                //   return {
                //     onClick: (event) => {}, // click row
                //   };
                // }}
              />
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
export default SO;
